/** Online group payment: user picks which participants to cancel. Office/cash flow unchanged. */
export function bookingNeedsParticipantCancellationSelection(booking) {
  if (!booking?.groupPayment?.isOnlineGroup) return false;
  const members = Array.isArray(booking?.groupMembers) ? booking.groupMembers : [];
  return members.length > 1;
}

export function groupMembersForCancellation(booking) {
  if (!Array.isArray(booking?.groupMembers)) return [];
  return booking.groupMembers.filter(
    (m) => m && Number.isFinite(Number(m.registrationId)) && String(m.name || '').trim()
  );
}
